<template>
    <div id="header">
        <div v-if="!isLiveServer"
             class="indecator">
            {{envIndecator}}
        </div>
        <div class="inner">
            <div v-if="$vuetify.breakpoint.xs"
                 >
                 <div class="d-flex">
                 <h1 class="logo">
                    <a href="javascript:void(0);">
                        <img class="changeNationLogo" src="images/gcpc-logo.png" alt="Logo" />
                    </a>
                </h1>
                </div>
                <v-bottom-sheet v-model="sheet">
                    <v-sheet class="text-center">
                        <!-- <div class="mobileMenus">
                            <a id="sectionMove" href="#section0" v-smooth-scroll
                               @click="selectedMenu.value = 0"
                               :class="{headerMenuBtn: true, active: selectedMenu.value == 0}">
                                {{ $store.getters.getLangValue('key-10') }}
                            </a>
                            <a id="sectionMove" href="#section1" v-smooth-scroll
                               @click="selectedMenu.value = 1"
                               :class="{headerMenuBtn: true, active: selectedMenu.value == 1}">
                                <span v-if="$store.state.isPreRegOpen">
                                    {{ $store.getters.getLangValue('key-11') }}
                                </span>
                                <span v-else>
                                    {{ $store.getters.getLangValue('gamesite-go') }}
                                </span>
                            </a>
                            <a id="sectionMove" href="#section4" v-smooth-scroll
                               @click="selectedMenu.value = 2"
                               :class="{headerMenuBtn: true, active: selectedMenu.value == 2}">
                                {{ $store.getters.getLangValue('key-12') }}
                            </a>
                            <a id="sectionMove" href="#section3" v-smooth-scroll
                               @click="selectedMenu.value = 3"
                               :class="{headerMenuBtn: true, active: selectedMenu.value == 3}">
                                {{ $store.getters.getLangValue('key-13') }}
                            </a>
                        </div> -->
                        <v-divider></v-divider>
                        <div class="text-center my-4"
                             v-if="$store.state.isPreRegOpen">
                            <v-btn :href="discodeURL"
                                   target="_blank"
                                   x-small
                                   text
                                   color="#7c798d">
                                <v-icon>
                                    fa-brands fa-discord
                                </v-icon>
                            </v-btn>
                            <v-btn text
                                   color="#7c798d"
                                   :href="instaURL"
                                   target="_blank"
                                   x-small>
                                <v-icon>
                                    fa-brands fa-instagram
                                </v-icon>
                            </v-btn>
                            <v-btn text
                                   color="#7c798d"
                                   :href="facebookURL"
                                   target="_blank"
                                   x-small>
                                <v-icon>
                                    fa-brands fa-square-facebook
                                </v-icon>
                            </v-btn>
                            <v-btn text
                                   color="#7c798d"
                                   :href="youtubeURL"
                                   target="_blank"
                                   x-small>
                                <v-icon>
                                    fa-brands fa-youtube
                                </v-icon>
                            </v-btn>
                            <v-btn text
                                   color="#7c798d"
                                   :href="xURL"
                                   target="_blank"
                                   x-small>
                                <v-icon>
                                    fa-brands fa-x-twitter
                                </v-icon>
                            </v-btn>
                        </div>
                        <v-divider ></v-divider>
                        <v-btn class="my-1"
                               color="error"
                               width="98%"
                               @click="sheet = !sheet">
                            <v-icon>
                                fa-solid fa-xmark
                            </v-icon>
                        </v-btn>
                    </v-sheet>
                </v-bottom-sheet>
            </div>

            <div class="d-flex align-center"
                 v-else>
                <h1 class="logo">
                    <a href="javascript:void(0);">
                        <img class="changeNationLogo" src="images/gcpc-logo.png" alt="Logo" />
                    </a>
                </h1>
                <!-- <a id="sectionMove" href="#section0" v-smooth-scroll
                   @click="selectedMenu.value = 0"
                   :class="{headerMenuBtn: true, active: selectedMenu.value == 0}">
                    {{ $store.getters.getLangValue('key-10') }}
                </a>
                <a id="sectionMove" href="#section1" v-smooth-scroll
                   @click="selectedMenu.value = 1"
                   :class="{headerMenuBtn: true, active: selectedMenu.value == 1}">
                    <span v-if="$store.state.isPreRegOpen">
                        {{ $store.getters.getLangValue('key-11') }}
                    </span>
                    <span v-else>
                        {{ $store.getters.getLangValue('gamesite-go') }}
                    </span>
                </a>
                <a id="sectionMove" href="#section4" v-smooth-scroll
                   @click="selectedMenu.value = 2"
                   :class="{headerMenuBtn: true, active: selectedMenu.value == 2}">
                    {{ $store.getters.getLangValue('key-12') }}
                </a>
                <a id="sectionMove" href="#section3" v-smooth-scroll
                   @click="selectedMenu.value = 3"
                   :class="{headerMenuBtn: true, active: selectedMenu.value == 3}">
                    {{ $store.getters.getLangValue('key-13') }}
                </a> -->
            </div>

            <div class="d-flex align-center mr-2">
                <!-- <div class="sound-toggle">
                    <v-btn class="sound-btn mr-2"
                           color="transparent"
                           icon
                           :class="{ active :!isMuted}"
                           size="small"
                           @click="toggleSound"
                           style="box-shadow:none;"
                           :width="$vuetify.breakpoint.xs ? '30px' : '49px'"
                           :height="$vuetify.breakpoint.xs ? '30px' : '49px'">
                        <img :src="isMuted ? `images/sound-off.png` : `images/sound-on.png`"
                             style="width:100%; height:auto;"
                             :class="{mobileSoundImg : $vuetify.breakpoint.xs }"/>
                    </v-btn>

                    <audio ref="bgm" loop>
                        <source src="audio/gcp_sound.mp3" type="audio/mpeg" />
                    </audio>

                </div> -->
                <div class="snsBtns"
                     v-if="!$vuetify.breakpoint.xs">
                 

                    <template v-if="$store.state.isPreRegOpen">
                        <v-btn :href="discodeURL"
                               target="_blank"
                               x-small
                               text
                               color="#7c798d">
                            <v-icon>
                                fa-brands fa-discord
                            </v-icon>
                        </v-btn>
                        <v-btn text
                               color="#7c798d"
                               :href="instaURL"
                               target="_blank"
                               x-small>
                            <v-icon>
                                fa-brands fa-instagram
                            </v-icon>
                        </v-btn>
                        <v-btn text
                               color="#7c798d"
                               :href="facebookURL"
                               target="_blank"
                               x-small>
                            <v-icon>
                                fa-brands fa-square-facebook
                            </v-icon>
                        </v-btn>
                        <v-btn text
                               color="#7c798d"
                               :href="youtubeURL"
                               target="_blank"
                               x-small>
                            <v-icon>
                                fa-brands fa-youtube
                            </v-icon>
                        </v-btn>
                        <v-btn text
                               color="#7c798d"
                               :href="xURL"
                               target="_blank"
                               x-small>
                            <v-icon>
                                fa-brands fa-x-twitter
                            </v-icon>
                        </v-btn>
                    </template>
                </div>

                
                <v-btn  v-if="$vuetify.breakpoint.xs"
                    dark
                    text
                    fab
                    @click="sheet = !sheet"
                    small>
                    <v-icon>
                        fa-solid fa-bars
                    </v-icon>
                </v-btn>
                <div class="dropdown">
                    <!--@click="toggleSound"-->


                    <button class="btn" type="button" data-toggle="dropdown"
                            v-on:click="isDropdownMenu = !isDropdownMenu">
                        <span id="btnCurrentLang"> {{ $store.getters.getLangValue('language') }}</span>
                        <span class="arrowIcon">
                            <i class="fa-solid fa-caret-down"></i>
                        </span>
                    </button>
                    <transition name="drop-down">
                        <ul id="listLanguage" class="dropdown-menu"
                            v-if="isDropdownMenu">
                            <li v-for="(langs,keys)  in $store.state.langValues.language"
                                :key="keys">
                                <a :href="'?lang=' + keys">
                                    {{ langs }}
                                </a>
                            </li>
                        </ul>
                    </transition>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isDropdownMenu: false,
                envIndecator: process.env.NODE_ENV,
                isLiveServer: false,
                selectedMenu: {
                    title: '메인',
                    value: 0
                },
                sheet: false,
                isMuted: true,
                discodeURL: 'https://discord.com/invite/grandchaseclassic',
                instaURL: 'https://www.instagram.com/gcclassic_official/',
                facebookURL: 'https://www.facebook.com/GrandChaseClassic',
                youtubeURL: 'https://www.youtube.com/@GrandChaseClassic',
                xURL: 'https://x.com/GrandChase/'
            }
        },
        created() {
            this.isLiveServer = process.env.NODE_ENV == 'production'
            
        },
        mounted() {
            const bgm = this.$refs.bgm
            bgm.volume = 0.5
            bgm.pause() 
        },
        computed: {
            twitterShareLink() {
                return `https://twitter.com/share?url=https://classic.grandchase.net/event/uno&text=${this.$store.getters.getLangValue("key-66")}&hashtags=${this.$store.getters.getLangValue("key-67")},${this.$store.getters.getLangValue("key-68")},${this.$store.getters.getLangValue("key-69")},${this.$store.getters.getLangValue("key-70")},${this.$store.getters.getLangValue("key-71")},${this.$store.getters.getLangValue("key-76")}`
            },
            facebookShareLink() {
                return `https://www.facebook.com/`
            },
            instaShareLink() {
                return 'https://www.instagram.com/'
            }
        },
        methods: {
            toggleSound() {
                const bgm = this.$refs.bgm
                this.isMuted = !this.isMuted
                if (this.isMuted) {
                    bgm.pause()
                } else {
                    bgm.volume = 0
                    bgm.play()
                    const fade = setInterval(() => {
                        if (bgm.volume < 0.5) bgm.volume += 0.05
                        else clearInterval(fade)
                    }, 100)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/scss/_variables.scss';
    .sound-btn {
        animation: clickMe 2s ease-in-out infinite;

        &.active {
            animation: none;
            transform: scale(0.97);
        }

        .mobileSoundImg {
            width: 34px !important;
            height: 34px !important;
        }
    }

    @keyframes clickMe {
        0%, 100% {
            transform: scale(1) rotate(0deg);
        }

        10% {
            transform: scale(1.05) rotate(-2deg);
        }

        20% {
            transform: scale(1.05) rotate(2deg);
        }

        30% {
            transform: scale(1.08) rotate(-1deg);
        }

        40% {
            transform: scale(1.08) rotate(1deg);
        }

        50% {
            transform: scale(1.1);
        }

        60%, 100% {
            transform: scale(1) rotate(0deg);
        }
    }

    .dropdown-menu {
        padding-left: 0;
    }
    .drop-down-enter-active {
        transition: all .3s ease;
    }

    .drop-down-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .drop-down-enter, .drop-down-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(-10px);
        opacity: 0;
    }

    .mobileMenus {
        
        .headerMenuBtn {
            display: block;
            color: #7c798d;
            padding: 20px 10px;
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            text-align: center;

            &.active {
                background: #55252d;
                color: #fff;
                position: relative;

                &:after {
                    display: block;
                    clear: both;
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 5px;
                    background: #e74157;
                    bottom: 0;
                    left: 0;
                }
            }
        }
    }

    #header {
        width: 100%;
        height: 100px;
        background: transparent;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        transition: all .4s;

        .headerMenuBtn {
            color: #7c798d;
            width: 200px;
            padding: 0 5px;
            font-size: 18px;
            font-weight: bold;
            text-align: center;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;

            &.active {
                color: #fff;
                position: relative;
            }
        }

        .indecator {
            position: absolute;
            top: 0;
            left: 0;
            background: red;
            color: #fff;
            width: 100%;
            padding: 0;
            text-align: center;
            font-size: 12px;
            font-weight: bold;
        }

        .inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            height: 100%;
            max-width: 1920px;
            width: 100%;
            margin: 0 auto;

            .snsBtns {
                margin-left: 4px;

                img {
                    width: 30px;
                    height: auto;
                }
            }
            .dropdown {
                position: relative;

                button {
                    width: 140px;
                    height: 40px;
                    background: #122838;
                    cursor: pointer;
                    color: #f1f1f1;
                    font-size: 16px;
                    border: solid 1px rgba(255,255,255,0.3);
                    position: relative;
                    text-align: left;
                    padding: 0 20px;

                    .arrowIcon {
                        position: absolute;
                        top: 50%;
                        right: 20px;
                        transform: translateY(-50%);
                        transition: all 0.4s;

                        &.on .arrowIcon {
                            transform: rotate(180deg) translateY(40%);
                        }
                    }

                    #btnCurrentLang {
                        margin-right: 10px;
                    }
                }

                ul {
                    position: absolute;
                    top: 40px;
                    left: 0;
                    background: #fff;
                    border-radius: 5px;
                    border: solid 1px #000;
                    box-sizing: border-box;
                    box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.3);
                    overflow: hidden;
                    width: 140px;
                    text-align: center;

                    li a {
                        color: #1f1f1f;
                        font-weight: 500;
                        padding: 8px 20px;
                        font-size: 14px;
                        transition: all 0.4s;
                        display: block;

                        &:hover {
                            background: #122838;
                            color: #e1dac8;
                        }
                    }
                }
            }

            .logo {
                height: 100%;
                width: 140px;
                margin-left: 20px;

                a {
                    display: flex;

                    img {
                        width: 100%;
                        height: auto;
                        transition: all 1s;
                    }
                }

                *:hover img {
                    transform: rotate3d(0, 1, 0, -360deg);
                }
            }
        }

        @include laptop {
        }


        @include tablet {
            height: 40px;

            .inner {
                .dropdown {
                    button {
                        padding: 0 10px;
                        height: 30px;
                        width: 100px;
                        font-size: 14px;
                    }

                    ul {
                        width: 100px;
                        top: 30px;

                        li {
                            a {
                                padding: 6px 20px;
                                font-size: 14px;
                            }
                        }
                    }
                }

                .logo {
                    width: 74px;
                    margin-top: 5px;
                }
            }
        }

        @include mobile {
            .inner {
                .snsBtns {
                    margin-left: 4px;

                    img {
                        width: 20px;
                        height: auto;
                    }
                }

                .dropdown {
                    button {
                        font-size: 13px;

                        .arrowIcon {
                            right: 10px;
                        }
                    }

                    ul {
                        li {
                            a {
                                font-size: 13px;
                            }
                        }
                    }
                }
            }
        }
    }

    #listLanguage {
        background: #000;
    }
</style>

